import { AvailableOnCallSpecialist } from '~/domain/usecases/onCallSpecialist/remote';
import {
  NotFound,
  BadRequestError,
  Forbidden,
  UnexpectedError,
  BadGateway,
} from '~/domain/errors';
import { HttpClient, HttpStatusCode } from '~/data/protocols/http';
import '~/infra/global/variables';

export class RemoteAvailableOnCallSpecialist
  implements AvailableOnCallSpecialist
{
  private readonly url: string;

  private readonly httpClient: HttpClient<AvailableOnCallSpecialist.Model>;

  constructor(
    url: string,
    httClient: HttpClient<AvailableOnCallSpecialist.Model>,
  ) {
    this.url = url;
    this.httpClient = httClient;
  }

  available = async (
    params: AvailableOnCallSpecialist.Params,
  ): Promise<AvailableOnCallSpecialist.Model> => {
    const httpResponse = await this.httpClient.request({
      url: this.url
        .replace('{onCallId}', params.onCallId.toString())
        .replace('{specialistId}', params.specialistId.toString()),
      method: 'post',
    });
    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
      case HttpStatusCode.accepted:
      case HttpStatusCode.noContent:
        return httpResponse.body;
      case HttpStatusCode.badRequest:
        throw new BadRequestError();
      case HttpStatusCode.notFound:
        throw new NotFound();
      case HttpStatusCode.unauthorized:
        throw new Forbidden();
      case HttpStatusCode.badGateway:
        throw new BadGateway();
      default:
        throw new UnexpectedError();
    }
  };
}
